import { Box } from '@mui/material';

import { ConfirmationData } from '@widget/presets/BookAppointmentThankYouPage/ConfirmationData';
import { Typography } from '@toolbox/components';
import { getUserTimeZone } from '@widget/utils/getUserTimezone';

import type { AppointmentType, BookedSlotType } from '@widget/api/types';
import type { FC } from 'react';

export const TEXT = {
  AppointmentTitle: 'Termindetails',
  BookedSlotTitle: 'Vielen Dank für Ihr Interesse an McMakler',
  BookedSlotText:
    'Wir sehen, dass wir bereits mit Ihnen Kontakt aufgenommen und Sie einen Termin mit einem unserer Makler vereinbart haben',
};

interface BookedSlotProps {
  bookedSlot: BookedSlotType;
  phone: string;
  address: string;
  bookedSlotTitle?: string;
  bookedSlotText?: string;
  appointmentTitle?: string;
  appointmentType: AppointmentType;
}

export const BookedSlot: FC<BookedSlotProps> = ({
  bookedSlot,
  phone,
  address,
  appointmentType,
  bookedSlotTitle = TEXT.BookedSlotTitle,
  bookedSlotText = TEXT.BookedSlotText,
  appointmentTitle = TEXT.AppointmentTitle,
}) => {
  const timezone = getUserTimeZone();
  return (
    <>
      <Typography variant="h3" mb={2} textAlign={'center'}>
        {bookedSlotTitle}
      </Typography>
      <Typography variant="b1" mb={2} textAlign={'center'}>
        {bookedSlotText}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} mt={4}>
        <Typography variant="h4" mb={6}>
          {appointmentTitle}
        </Typography>
        <ConfirmationData
          isoString={bookedSlot.startTime}
          timezone={timezone}
          phone={phone}
          address={address}
          appointmentType={appointmentType}
        />
      </Box>
    </>
  );
};
